import {z} from 'zod';

const youtubeStandardRegex = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=[\w-]{11}($|&|#)/;
const youtubeShortRegex = /^(https?:\/\/)?(www\.)?youtu\.be\/[\w-]{11}($|[?#])/;
const vimeoStandardRegex = /^(https?:\/\/)?(www\.)?vimeo\.com\/\d+($|[?#])/;

const videoUrlSchema = z
    .string()
    .refine((url) => youtubeStandardRegex.test(url) || youtubeShortRegex.test(url) || vimeoStandardRegex.test(url), {
        message: 'elementModal.video.invalidEmbededVideo',
    });

function extractVideoId(url: string): string | null {
    if (youtubeStandardRegex.test(url)) {
        const match = url.match(/[?&]v=([\w-]{11})/);
        return match ? match[1] : null;
    }
    if (youtubeShortRegex.test(url)) {
        const match = url.match(/youtu\.be\/([\w-]{11})/);
        return match ? match[1] : null;
    }
    if (vimeoStandardRegex.test(url)) {
        const match = url.match(/vimeo\.com\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
}
export function getEmbedUrl(url: string): string {
    const videoId = extractVideoId(url);
    if (!videoId) return '';

    if (url.includes('youtube.com') || url.includes('youtu.be')) {
        return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes('vimeo.com')) {
        return `https://player.vimeo.com/video/${videoId}`;
    }

    return '';
}

export function validateEmbeddedVideo(url: string): void {
    videoUrlSchema.parse(url);
}
